import * as React from "react";
import { Colorizer } from "./colorizer";
import { SidingType, SidingColor, shakeSidingColors, shingleSidingColors, SidingSupportedConfigurations, trimColors, singleDoubleColors, dutchLapColors } from "./colors";
import _ from "lodash";

var COLORIZER_CONFIG = (window.location.hash || "-1.-1.0.-1.0.-1.0").replace("#", "").split('.').map(function(num) { return parseInt(num, 10); });


let allColors: SidingColor[] = _(SidingColor).keys().filter(x => isNaN(parseInt(x, 10))).map(x => SidingColor[x]).value();
let boardBatten = _.reject(allColors, (color: SidingColor) => [SidingColor.Ebony].indexOf(color) >= 0);

let configurationsFor = (type: SidingType) => {
	switch (type) {
		case SidingType.Shingle:
			return new SidingSupportedConfigurations(type, shingleSidingColors);
		case SidingType.Shake:
			return new SidingSupportedConfigurations(type, shakeSidingColors);
        case SidingType.BoardBatten:
            return new SidingSupportedConfigurations(type, boardBatten);
        case SidingType.DutchLap:
			return new SidingSupportedConfigurations(type, dutchLapColors);
		case SidingType.Double4:
		case SidingType.Double5:
		case SidingType.Single8:
			return new SidingSupportedConfigurations(type, singleDoubleColors);
		default:
			return new SidingSupportedConfigurations(type, allColors);
	}
};

var trimOptions = [
	new SidingSupportedConfigurations(SidingType.Trim, trimColors)
];

var aOptions = _([
    SidingType.SelectSiding,
	SidingType.BoardBatten,
	SidingType.Double4,
	SidingType.Double5,
	SidingType.DutchLap,
	SidingType.Shake,
	SidingType.Shingle,
	SidingType.Single8
]).map(x => configurationsFor(x)).value();

var bOptions = _([
    SidingType.SelectSiding,
	SidingType.BoardBatten,
	SidingType.Double4,
	SidingType.Double5,
	SidingType.DutchLap,
	SidingType.Shake,
	SidingType.Shingle,
	SidingType.Single8
]).map(x => configurationsFor(x)).value();

var cOptions = _([
    SidingType.SelectSiding,
	SidingType.Double4,
	SidingType.Double5,
	SidingType.DutchLap,
	SidingType.Single8
]).map(x => configurationsFor(x)).value();



// Start the app.
export const App = () => <Colorizer baseUrl={""} configurations={[trimOptions, aOptions, bOptions, cOptions]} initialSelection={COLORIZER_CONFIG}/>